// Label nomor antrian, SAMA dengan server (backend utils/nomorAntrian.js) dan aplikasi HP: awalan + nomor 3 digit,
// mis. "012" atau "L007" (nomor lokal HP offline). Menerima objek transaksi (nomorAntrian + awalanAntrian); '' bila tidak ada.
export const labelAntrian = (trx) => {
  if (!trx || trx.nomorAntrian === null || trx.nomorAntrian === undefined || trx.nomorAntrian === '') return '';
  const n = parseInt(trx.nomorAntrian, 10);
  if (!Number.isFinite(n)) return '';
  return `${(trx.awalanAntrian || '').toString().trim()}${String(n).padStart(3, '0')}`;
};
